import { render, staticRenderFns } from "./Anchorinfo.vue?vue&type=template&id=11364fb8&scoped=true&"
import script from "./Anchorinfo.vue?vue&type=script&lang=js&"
export * from "./Anchorinfo.vue?vue&type=script&lang=js&"
import style0 from "./Anchorinfo.vue?vue&type=style&index=0&id=11364fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11364fb8",
  null
  
)

export default component.exports